/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../../project/configs/config";

const epName = "v1/gc-cobranza/";
const epName1 = "v1/cobranza/";
const nameItemsText = "Cobranza";
const nameItemText = "Cobranza";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getCobranzas = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Cobranzas";

  // limpio los parametros de busqueda segun corresponda al tipo de cobro seleccionado

  switch (params.tipoCobro) {
    case "efectivo":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "tarjeta-debito":
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "tarjeta-credito":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "billetera-virtual":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "obra-social":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "descuento-especial":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "otro":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "transferencia-bancaria":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "cheque":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      break;
  }

  if (params.codigoCobranza) {
    _params.cobranza_codigo = params.codigoCobranza;
  }

  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
  }

  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
  }

  if (params.estadoActual) {
    _params.estado_actual = params.estadoActual;
  }

  if (params.usuario) {
    _params.id_usuario = params.usuario;
  }

  _params.id_area = localStorage.getItem("id_area_ventas");

  if (params.codigoGA) {
    _params.gc_codigo = params.codigoGA;
  }

  if (params.nombre) {
    _params.cliente_nombre = params.nombre;
  }

  if (params.apellido) {
    _params.cliente_apellido = params.apellido;
  }

  if (params.tipoCobro) {
    _params.tipo_cobro = params.tipoCobro;
  }

  if (params.tarjetaDebito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaDebito;
  }

  if (params.numeroCuponTarjetaDebito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaDebito;
  }

  if (params.numeroLoteTarjetaDebito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaDebito;
  }

  if (params.tarjetaCredito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaCredito;
  }

  if (params.numeroCuponTarjetaCredito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaCredito;
  }

  if (params.numeroLoteTarjetaCredito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaCredito;
  }

  if (params.billetera) {
    _params.id_billetera = params.billetera;
  }

  if (params.obraSocial) {
    _params.id_obra_social = params.obraSocial;
  }

  if (params.obraSocialPlan) {
    _params.id_obra_social_plan = params.obraSocialPlan;
  }

  if (params.numeroBeneficiario) {
    _params.numero_beneficiario_obra_social = params.numeroBeneficiario;
  }

  if (params.numeroAutorizacion) {
    _params.numero_autorizacion_obra_social = params.numeroAutorizacion;
  }

  if (params.descripcionDescuentoEspecial) {
    _params.descripcion = params.descripcionDescuentoEspecial;
  }

  if (params.descripcionOtraFormadeCobro) {
    _params.descripcion = params.descripcionOtraFormadeCobro;
  }

  if (params.cuentaBancaria) {
    _params.id_cuenta_bancaria = params.cuentaBancaria;
  }

  if (params.numeroComprobante) {
    _params.numero_comprobante_cuenta_bancaria = params.numeroComprobante;
  }

  if (params.banco) {
    _params.banco_cheque = params.banco;
  }

  if (params.numeroCheque) {
    _params.numero_cheque = params.numeroCheque;
  }

  if ("rows" in params) {
    _params.rows = params.rows;
  }

  if ("first" in params) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName1}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getGAsCobranza = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Gestiones de Atención";

  let _idsGAs = "";
  params.forEach((item) => {
    _idsGAs += item.id + " ";
  });

  _params.ids_gas = _idsGAs.trim();

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveCobranza = async (actionCrud, cobranza) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

  cobranza.id_area = localStorage.getItem("id_area_ventas");
  cobranza.id_usuario = localStorage.getItem("id_usuario");

  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epName1}`,
        data: cobranza,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epName1}`,
        data: cobranza,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemText}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-cobranza-caja-revision-not-allowed") {
          response.messageText = "No es posible guardar la Cobranza ya que la Caja actual se encuentra en estado de revisión";
        } else if (_message_code === "err-cobranza-cambio-importe-pendiente-pago-total-not-allowed") {
          response.messageText = "No es posible guardar la Cobranza ya que cambio el importe pendiente de pago";
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const invalidateCobranza = async (idCobranza) => {
  let _errorMessage = `No fue posible anular ${elLa} ${nameItemText}`;

  try {
    const response = await axios({
      method: "DELETE",
      url: `${urlCoreBack}${epName1}`,
      params: {
        id: idCobranza,
        id_usuario: localStorage.getItem("id_usuario"),
        id_area: localStorage.getItem("id_area_ventas"),
        motivo_anulacion: "anulacion",
      },
    });

    if (response.status === 200) {

      let _error = "status" in response.data && response.data.status === "error";

      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemText}` + " anulada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-cobranza-anulacion-odoo-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible anular una cobranza que no ha sido enviada a Odoo";
        response.messageSeverity = "info";
        return response;
      } else if (response.data.code === "err-cobranza-anulacion-caja-revision-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible anular la cobranza debido a que la caja actual se encuentra en estado de revisión";
        response.messageSeverity = "error";
        return response;
      } else if (response.data.code === "err-cobranza-anulacion-caja-cerrada-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible anular la cobranza debido a que la caja en la que se registró se encuentra cerrada";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getCobranza = async (idCobranza) => {
  let _errorMessage = "Se produjo un error al obtener la Cobranza";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}v1/cobranza/`,
      params: { id: idCobranza },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

